import _ from 'lodash';
export default {
	getSearchDates_({ searchParams: { strDt, endDt } }) {
		return [strDt, endDt];
	},
	getSndStListFiltered_({ sndStList }) {
		return sndStList.filter(el => el.value === 'NSND' || el.value === 'ET_FAIL'); //ET_FAIL : 발송실패, NSND : 미발송
	},
	getCheckWriterSelf_({ detailForm }, getters, rootState) {
		const loginUserId = window.atob(rootState['commonStore'].user.userId);
		if (!detailForm.rgnId) return true;
		return detailForm.rgnId === loginUserId;
	},
	getCheckReplyAuth_({ detailForm }, getters, rootState) {
		const rcptAdrs = detailForm.rcptAdr?.split(';') || [];
		return rcptAdrs.length && !!rcptAdrs.includes(rootState['commonStore'].user.email);
	},
	//진행상태 selectBox
	getPgsStPtCdList_({ pgsStPtCdList }) {
		const list = [];
		pgsStPtCdList.length && pgsStPtCdList.forEach(row => list.push({ label: row.label, value: row.value }));
		return list;
	},
	getAffrInfo_({ rmkHistory, detailForm }, getters, rootState) {
		let writerNm = rootState['commonStore'].user.userName, //작성자
			writeDd = '',
			writerId = detailForm.rgnId,
			mdvNm = '', //회신자
			csetNm = '', //승인자
			csetDd = '';
		if (rmkHistory.length > 0) {
			const currentPgsStCd = Number(rmkHistory[0].pgsStCd);
			if (currentPgsStCd == 20) {
				//작성
				writerNm = rmkHistory[0].affrDspoNm;
				writerId = rmkHistory[0].affrDspoId;
				writeDd = rmkHistory[0].affrPrcsDt;
			} else if (currentPgsStCd == 30 || currentPgsStCd == 40) {
				if (currentPgsStCd == 30) {
					//회신
					mdvNm = rmkHistory[0].affrDspoNm;
				} else {
					csetNm = rmkHistory[0].affrDspoNm;
					csetDd = rmkHistory[0].affrPrcsDt;
					const mdvInfo = _.find(rmkHistory, { pgsStCd: '30' });
					mdvNm = mdvInfo?.affrDspoNm;
				}

				const writerInfo = _.find(rmkHistory, { pgsStCd: '20' });
				writerNm = writerInfo?.affrDspoNm;
				writeDd = writerInfo?.affrPrcsDt;
				writerId = writerInfo?.affrDspoId;
			}
		}
		return { writerNm, writeDd, csetNm, csetDd, writerId, mdvNm };
	},
	detailFormData_({ detailForm }, getters) {
		const formData = new FormData();

		for (const [key, val] of Object.entries(detailForm)) {
			if (!val) continue;
			else if (key === 'powPrbmFileDb' || key === 'powCausFileDb' || key === 'powImg1FileDb' || key === 'powImg2FileDb') continue;
			else if (key === 'powPrbmFile' || key === 'powCausFile') {
				val.length && val.forEach(file => formData.append(key, file));
			} else formData.set(key, val);
		}

		//메일 발송 완료 및 임시 저장이 아니고,
		if (detailForm.sndStCd !== 'SND_CMPL' && detailForm.sndStCd !== 'TMP_STG') {
			//조치처나 참조처가 하나라도 있을 경우 메일을 '미발송' 상태로 설정한다.
			if (!!detailForm.rcptAdr || !!detailForm.rfpAdr) {
				formData.set('sndStCd', 'NSND');
			}
		}

		return formData;
	},
	detailFormUpdate_({ detailForm }) {
		const {
			powLnCd,
			insnDd,
			emlSndSignal,
			sndStCd,
			dsprNm,
			powBttmInfmNo,
			affrPrcsId,
			rmk,
			pgsStCd,
			powPrbmTitl,
			powPrbmSbc,
			powPrbmFileId,
			powImg1FileId,
			powImg2FileId,
			powCausFileId,
			dsprAdr,
			dsprId,
			rcptNm,
			rcptAdr,
			rfpNm,
			rfpAdr,
			rcptBcNm,
			rcptBcAdr,
			rfpBcNm,
			rfpBcAdr
		} = detailForm;
		let emlSndStCd = sndStCd;

		//메일 발송 완료 및 임시 저장이 아니고,
		if (sndStCd !== 'SND_CMPL' && sndStCd !== 'TMP_STG') {
			//조치처나 참조처가 하나라도 있을 경우 메일을 '미발송' 상태로 설정한다.
			if (!!rcptAdr || !!rfpAdr) {
				emlSndStCd = 'NSND';
			}
		}

		return {
			powLnCd,
			insnDd,
			emlSndSignal,
			sndStCd: emlSndStCd,
			dsprNm,
			powBttmInfmNo,
			affrPrcsId,
			rmk,
			pgsStCd,
			powPrbmTitl,
			powPrbmSbc,
			powPrbmFileId,
			powImg1FileId,
			powImg2FileId,
			powCausFileId,
			dsprAdr,
			dsprId,
			rcptNm,
			rcptAdr,
			rfpNm,
			rfpAdr,
			rcptBcNm,
			rcptBcAdr,
			rfpBcNm,
			rfpBcAdr
		};
	},
	powTourSttsManagementCols(state, getters, rootState, rootGetters) {
		//그리드 컬럼
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001390'), //검사일
				prop: 'insnDdView',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001390'), //검사일
				prop: 'insnDd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001911'), //검사차수
				prop: 'ipnNos',
				minWidth: '60px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001137'), // 라인
				prop: 'powLnCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001137'), // 라인
				prop: 'powLnNm',
				minWidth: '100px',
				custom: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001374'), //검사항목수
				prop: 'insnPrvsCt',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001375'), //적합항목수
				prop: 'okPrvsCt',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001376'), //부적합항목수
				prop: 'ngPrvsCt',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001421'), //적합율(%)
				prop: 'stblPro',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001422'), //이상통보서NO
				prop: 'powBttmInfmNo',
				minWidth: '120px',
				custom: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001094'), //진행상태(이상통보서상태)
				prop: 'pgsStCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001094'), //진행상태명(이상통보서상태명)
				prop: 'pgsStNm',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000009'), //검사원
				prop: 'pprrId',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000009'), //검사원
				prop: 'pprrNm',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001436'), //대책회신코드
				prop: 'mdvRplCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001436'), //대책회신명칭
				prop: 'mdvRplNm',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001444'), //대책일
				prop: 'mdvDd',
				minWidth: '80px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001460'), //조치처
				prop: 'rcptNm',
				minWidth: '230px'
			}
		];
	}
};
